import Icon from '../../common/components/Icon';
import React, { useMemo } from 'react';
import { useTranslations } from '../../localization/useTranslations';
import { ActivationHeaderProps } from '../types/CodeInfo';

const ActivationHeader: React.FC<ActivationHeaderProps> = ({ codeInfo, state }) => {
  const translations = useTranslations();

  const dynamicDescription = useMemo(() => {
    if (!codeInfo) {
      return '';
    }

    const donorName =
      codeInfo.donor?.first_name && codeInfo.donor?.last_name
        ? `${codeInfo.donor.first_name} ${codeInfo.donor.last_name}`
        : codeInfo.donor?.email;

    const loginPromptText =
      translations?.subscriptionActivation?.defaultHeaderText ||
      'You must log in or register to activate. Continue by entering your email, or log in via Google or Facebook.';

    const confirmAccountPromptText =
      translations?.subscriptionActivation?.confirmAccountPrompt || 'Would you like to activate it for this account?';

    const sharesWithYou = translations?.subscriptionActivation?.sharedbyLabel || 'shares with you';

    switch (state) {
      case 'login':
        return `${donorName} ${sharesWithYou} ${codeInfo.subscription?.name}. ${loginPromptText}`;

      case 'userCard':
        return `${donorName} ${sharesWithYou} ${codeInfo.subscription?.name}. ${confirmAccountPromptText}`;

      case 'addressCard':
      case 'addressForm':
        return (
          translations?.subscriptionActivation?.inputAddressPrompt ||
          'Please enter the address where we will send the Forbes magazine.'
        );

      default:
        return '';
    }
  }, [codeInfo, state, translations]);

  return (
    <div>
      <div className="page-subscription-activation__icon">
        <Icon name="diamond" size="xlarge" />
      </div>

      <h2 className="page-subscription-activation__title">
        {translations?.subscriptionActivation?.activationTitle || 'Subscription Activation'}
      </h2>

      <div className="page-subscription-activation__description">{dynamicDescription}</div>
    </div>
  );
};

export default ActivationHeader;
